<template class="fondo">
  <div class="loader" v-if="this.isLoading">
    <img class="rounded mx-auto d-block" src="@/assets/loading.gif" />
  </div>
  <div class="contenedor fondo">
    <div class="d-flex contimg">
      <img src="@/assets/img2.png" class="imagens">
    </div>
    <div class="d-flex contimg2">
      <img src="@/assets/img1.png" class="imagens2">
      <div class="texto-derecha texto-derecha-mobile">
        <label>SI ERES SOCIO ENJOY CLUB</label>
        <div class="curadradoRojo">
          <label>JUEGA Y GANA UNO DE LOS</label><br>
          <label class="masFont">2.000</label><br>
          <label>VIAJES EN CRUCEROS</label><br>
        </div>
        <label>¡TÚ ELIGES EL DESTINO!</label>
      </div>
  </div>


    <div class="d-flex flex-column flex-md-row " style="margin-right: 5%; margin-left: 15%">

      <div id="opcionUno" class="opcion p-2 text-dark bg-opacity-50 form-rounded transparent col-md-4 col-12" style="margin-top: -12%">
        <div style="text-align: center; margin: 2%;">
          <h3 style="color: #FFFFFF; font-family: 'Gotham', sans-serif;">REVISA TU POSICIÓN EN EL RANKING</h3>
          <h3 style="color: #FFFFFF; font-family: 'Gotham', sans-serif;">Y CONOCE SI ERES UNO DE LOS 2000 GANADORES</h3>
        </div>
        <div style="width: 90%; display: flex; flex-direction: column; align-items: center; margin: 3%;">
          <input
  type="text"
  id="rut2"
  name="rut2"
  maxlength="10"
  v-model="rut2"
  class="form-control form-rounded textMobile2"
  style="text-align: center;"
  placeholder="RUT: 12345678-9"
/>
<span v-if="v2$.rut2.Fn.$invalid && v2$.rut2.$dirty" class="error">
  * Debe ingresar un RUT válido sin puntos y con guión
</span>        </div>
        <div style="margin: 4%; width: 100%; display: flex; justify-content: center;">

          <button class="form-rounded align-self-stretch btn-inscribir-nuevo" v-on:click="validaCampoRegistrado()" :disabled="isLoading" style="width: 70%;">
            <span>REVISA AQUÍ</span>
          </button>
        </div>


      </div>

      
    </div>
    <div class="container text-center">
  <div class="row">
    <div class="col-md-6">
      <img src="@/assets/img5.png" alt="Imagen 1" style="width: 100%;">
    </div>
    <div class="col-md-6">
      <img src="@/assets/img4.png" alt="Imagen 2" style="width: 100%;">
    </div>
  </div>
<br>
  <div class="row justify-content-center">
    <div class="col-md-8">
      <img src="@/assets/img6.png" alt="Imagen 1" style="width: 100%;">
    </div>
  </div>
  <br>

  <div class="row justify-content-center">
    <div class="col-md-8">
      <img src="@/assets/img7.png" alt="Imagen 1" style="width: 100%;">
    </div>
  </div>
  <br>

  <div class="row justify-content-center">
    <div class="col-md-8">
      <img src="@/assets/img8.png" alt="Imagen 1" style="width: 100%;">
    </div>
  </div>
  <br>
  <br>

  <div class="texto-center">
    <span class="texto-bold" >TODOS LOS PUNTOS QUE ACUMULES DESDE EL 13 DE OCTUBRE AL 01 DE DICIEMBRE DE 2023 CONTARÁN 
      PARA LA PROMOCIÓN, A PESAR DE QUE TU INSCRIPCIÓN SEA POSTERIOR A ESA FECHA
    </span>
  </div>
  <br>
  <br>
  <div class="texto-center">
    <p class="texto-white">Revisa las <a href="https://www.enjoy.cl/cruceros/bases.pdf" target="_blank" style="color: white;">bases y condiciones aquí</a>.</p>
  </div>
  <br>
</div>
</div>

<div class="row justify-content-center">
    <div class="col-md-12">
      <img src="@/assets/img3.png" alt="Imagen 1" style="width: 100%;">
    </div>
  </div>


  <!--<div v-if="true" class="footer heightFooter">
    <img src="@/assets/logoenjoy.png" alt="">
  </div>-->
</template>


<script>
import useValidate from '@vuelidate/core'
import axios from "axios";
import variables from '@/static/endPoint.json'
import { required, email, minLength, numeric, minValue,} from '@vuelidate/validators'
const Fn = {
  // Valida el rut con su cadena completa "XXXXXXXX-X"
  validaRut: function (rutCompleto) {
    rutCompleto = rutCompleto.replace("‐", "-");
    if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
    var tmp = rutCompleto.split("-");
    var digv = tmp[1];
    var rut = tmp[0];
    if (digv == "K") digv = "k";
    return Fn.dv(rut) == digv;
  },
  dv: function (T) {
    var M = 0,
      S = 1;
    for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
    return S ? S - 1 : "k";
  },
};

const Fn2 = {
  // Valida el rut con su cadena completa "XXXXXXXX-X"
  validaRut: function (rutCompleto) {
    rutCompleto = rutCompleto.replace("‐", "-");
    if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
    var tmp = rutCompleto.split("-");
    var digv = tmp[1];
    var rut2 = tmp[0];
    if (digv == "K") digv = "k";
    return Fn.dv(rut2) == digv;
  },
  dv: function (T) {
    var M = 0,
      S = 1;
    for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
    return S ? S - 1 : "k";
  },
};

export default ({
    name: 'Valida',
    data() {
        return {
            v$:useValidate(),
            v2$:useValidate(),
            rut:'',
            rut2:'',
            mail:'',
            isLoading:false,
            variables:variables
        }
    },
    validations() {
      return {
        rut: { Fn: Fn.validaRut },
        mail: {
          required,
          email,
        },
        rut2: { Fn: Fn2.validaRut }, // Separate validation rule for rut2
      };
    },
    components: {
        
    },
    methods:{
      validaCampo(){
        this.v$.$touch();
        this.v$. $validate()
        if (!this.v$.rut.Fn.$invalid) {
          this.isLoading=true;
          var dni = this.rut.replace('-',"");
          var datos={
                  dni: dni, 
                  correo: this.mail, 
                  promocion: "CRUCOCT", 
                  origen: "web" 
                }
          axios
          .post(this.variables.postGuardar,datos)
            .then((data)=>{
                this.$store.commit('SET_MOSTRAR_VALIDACION',false);
                this.$store.commit('SET_MOSTRAR_DESAFIO',true);
                var idCliente = data.data.cliente.idCliente;
                this.$store.commit('SET_ID_CLIENTE',idCliente);
                this.datosCliente(idCliente);
                console.log(data);
            })
            .catch((error) => {
              console.log(error.response)
              this.$store.commit('SET_ID_CLIENTE',dni);

              this.isLoading=false;
              if(error.response.status==400){
                switch(error.response.data.tipo){
                  case('NOCUMPLE'):
                    this.$store.commit('SET_MOSTRAR_VALIDACION',false);
                    this.$store.commit('SET_MOSTRAR_DESAFIO_EXCLUSIVO',true);
                    this.$store.commit('SET_MOSTRAR_DESAFIO',false);

                  break;
                  case('FINALIZADO'):
                    this.$store.commit('SET_MOSTRAR_VALIDACION',false);
                    this.$store.commit('SET_MOSTRAR_FINALIZADO',true);
                  break;
                  case('AGOTADO'):
                    this.$store.commit('SET_MOSTRAR_VALIDACION',false);
                    this.$store.commit('SET_MOSTRAR_OPPS',true);
                  break;
                  case('INSCRITO'):
                  console.log(error.response.data.cliente.nombre)
                    this.$store.commit('SET_NOMBRE',error.response.data.cliente.nombre);

                    this.$store.commit('SET_MOSTRAR_VALIDACION',false);
                    this.$store.commit('SET_MOSTRAR_YA_REGISTRADO',true);
                  break;

                  case('NOINSCRITO'):
                  this.$store.commit('SET_MOSTRAR_VALIDACION',false);
                    this.$store.commit('SET_MOSTRAR_DESAFIO_EXCLUSIVO',true);                  
                    break;
                }
              }
            })
        }
      },
      validaCampoRegistrado(){
        this.v2$.$touch();
        this.v2$. $validate()
        if (!this.v2$.rut2.Fn.$invalid) {
          this.isLoading=true;
          var dni = this.rut2.replace('-',"");
          this.$store.commit('SET_ID_CLIENTE',dni);

          axios
        .get(this.variables.getValidar + dni)
            .then((data)=>{
              this.isLoading=false;
              this.$store.commit('SET_DATA',data);
              this.$store.commit('SET_MOSTRAR_VALIDACION',false);
              this.$store.commit('SET_MOSTRAR_AVANCE',true);
              console.log(data)

            })
            .catch((error) => {
              console.log(error)
              this.isLoading=false;
              if(error.response.status==400){
                switch(error.response.data.tipo){
                  case('NOCUMPLE'):
                    this.$store.commit('SET_MOSTRAR_VALIDACION',false);
                    this.$store.commit('SET_MOSTRAR_DESAFIO_EXCLUSIVO',true);
                  break;
                  case('FINALIZADO'):
                    this.$store.commit('SET_MOSTRAR_VALIDACION',false);
                    this.$store.commit('SET_MOSTRAR_FINALIZADO',true);
                  break;
                  case('AGOTADO'):
                    this.$store.commit('SET_MOSTRAR_VALIDACION',false);
                    this.$store.commit('SET_MOSTRAR_OPPS',true);
                  break;
                  case('INSCRITO'):
                  console.log("aca")
                    this.$store.commit('SET_MOSTRAR_VALIDACION',false);
                    this.$store.commit('SET_MOSTRAR_YA_REGISTRADO',true);
                  case('NOINSCRITO'):
                    this.$store.commit('SET_MOSTRAR_VALIDACION',false);
                    this.$store.commit('SET_MOSTRAR_DESAFIO_EXCLUSIVO',true);
                  break;
                }
              }
            })
        }
      },
      datosCliente(id){
        axios
          .get(this.variables.getIdCliente+id)
          .then((response)=>{
            this.$store.commit('SET_METAS',response.data);
            this.$store.commit('SET_MOSTRAR_VALIDACION',false);
            this.$store.commit('SET_MOSTRAR_DESAFIO',true);
            this.isLoading=false;
          })
          .catch(error=>{
            this.isLoading=false;
          })
      }
    },
    created(){
      window.scrollTo(0,0);
    }
})
</script>
<style>


/* Estilos para pantallas más grandes (por ejemplo, PCs) */
@media (min-width: 768px) {
  .contimg {
  display: flex;
  width: 100%; /* El div ocupa el 100% del ancho de la pantalla */
  align-items: left;
}


.imagens {
  width: 20%; /* La imagen ocupa el 20% del ancho del div */
  margin-top: 2%; /* Margen superior en dispositivos móviles */
  margin-left: 10%;
}

.contimg2 {
  display: flex;
  width: 100%;
  position: relative;
  margin-top: -10%;

}

.imagens2 {
  width: 100%;
}

.curadradoRojo{
  background-color: #d7332a; /* Fondo rojo */
  padding: 10px;

}
.texto-derecha {
  position: absolute;
  top: 50%;
  right: 5%;
  color: white; /* Texto en blanco */
  transform: translateY(-50%);
  text-align: center;
  font-size: 40px; /* Establece el tamaño de fuente solo para el segundo label */
  padding: 10px;
}

.texto-derecha label {
  font-weight: bold; /* Hace que todos los labels sean negrita */
  color: white; /* Texto en blanco */
  margin: auto;
  padding: auto;
}


.texto-derecha br {
  margin: 0%;
  padding: 0%;

}
.masFont {
  font-size: 150px; /* Establece el tamaño de fuente solo para el segundo label */
  color: white; /* Texto en blanco */
  margin: auto;
  padding: auto;

}

.texto-center {
  text-align: center;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 1%;
}

.texto-white {
  color: #FFFFFF;
  font-family: 'Gotham', sans-serif;
  font-weight: lighter; /* Texto ligero */
  font-size: 18px;
}

.texto-bold {
  font-weight: bold;
  font-size: 24px;
  color: #FFFFFF;

}

.texto-rojo {
  background-color: #d7332a;
  color: white; /* Color de texto blanco */
  padding: 5px 10px; /* Espaciado interno */
  border-radius: 4px; /* Bordes redondeados */
}

.textMobile{
    font-size: 36px;
  }

  .textMobile2{
    font-size: 32px !important;
  }

}

/* Estilos para pantallas más pequeñas (por ejemplo, dispositivos móviles) */
@media (max-width: 767px) {
  .textMobile{
    font-size: 16px;
  }

  
  .textMobile2{
    font-size: 16px  !important;
  }
  .contimg {
  width: 100%; /* El div ocupa el 100% del ancho de la pantalla */
  align-items: center;
  text-align: center;
}
  .imagens {
    width: 80%; /* Porcentaje de ancho para dispositivos móviles */

  }
  .contimg2 {
    display: flex;
    width: 100%;
    position: relative;
  }

  .imagens2 {
    width: 100%;
  }

  .curadradoRojo {
    background-color: #d7332a;
    padding: 10px;
  }

  .texto-derecha-mobile {
    font-size: 8px !important;
  }

  .texto-derecha {
    position: absolute;
    top: 50%;
    right: 5%;
    color: white;
    transform: translateY(-50%);
    text-align: center;
    font-size: 15px;
    padding: 10px;
  }

  .texto-derecha label {
    font-weight: bold;
    color: white;
    margin: auto;
    padding: auto;
  }

  .texto-derecha br {
    margin: 0;
    padding: 0;
  }

  .masFont {
    font-size: 20px;
    color: white;
    margin: auto;
    padding: auto;
  }

  .texto-center {
    text-align: center;
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 1%;
  }

  .texto-white {
    color: #FFFFFF;
    font-family: 'Gotham', sans-serif;
    font-weight: lighter;
    font-size: 18px;
  }

  .texto-bold {
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
  }

  .texto-rojo {
    background-color: #d7332a;
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
  }
}
</style>
